// "ของรุ่นเดียวกัน ต่างแค่สี/ไซส์" — กรอกครั้งเดียว ใช้ได้ทั้งรุ่น
//
// ที่มา (25 ต.ค. 2569): ใบ SP-261015 มี 114 บรรทัด แต่ไม่ใช่ของ 114 อย่าง —
//   CH-26SU00111023  GORE-TEX Rain Hat 1 GREIGE
//   CH-26SU00111062  GORE-TEX Rain Hat 1 LIGHT GREEN   ← วัสดุ/พิกัด/คำบรรยาย เหมือนกันแน่นอน
//   นับจริงแล้วเป็นของ ~36 รุ่น ⇒ กรอก 36 ครั้ง แทน 113 ครั้ง
//
// ⚠ กฎจับรุ่นนี้ "เดา" จากชื่อกับรหัส ไม่ใช่ข้อมูลที่แบรนด์ยืนยัน จึงมีข้อห้ามสองข้อ:
//   ① ห้ามเขียนทับช่องที่กรอกไว้แล้ว — เติมเฉพาะช่องที่ยังว่าง
//   ② ห้ามเขียนก่อนให้คนเห็นรายชื่อ — ต้องติ๊กยืนยันทีละรายการเสมอ
//   เคยเกือบพลาด: ถ้าใช้วิธี "ตัดท้ายรหัส 3 ตัว" TC-151 (กล่องทิชชู่) กับ TC-153 (กล่องผ้า)
//   จะกลายเป็นรุ่นเดียวกันทั้งที่เป็นของต่างชนิด → จึงต้องดูชื่อประกอบ ไม่ดูรหัสอย่างเดียว
//
// ⚠ ไม่คัดลอก hs_confirmed (ติ๊ก "broker ยืนยันแล้ว") และ is_dangerous_goods —
//   สองช่องนี้เป็น "คำยืนยัน" ของคน ไม่ใช่คุณสมบัติสินค้า ถ้าก๊อปไปจะกลายเป็นอ้างว่า
//   broker ตีพิกัดสีนั้นแล้วทั้งที่ยังไม่ได้ตี

// ช่องที่ของรุ่นเดียวกันใช้ค่าเดียวกันได้
export const FILLABLE = [
  ['what_is_it',     'คืออะไร ใช้ทำอะไร'],
  ['material',       'วัสดุ'],
  ['usage_desc',     'วิธีใช้งาน'],
  ['origin_country', 'ผลิตที่ประเทศ'],
  ['power_spec',     'สเปคไฟ'],
  ['category',       'หมวดสินค้า'],
  ['hs_code',        'พิกัด HS'],
];

import { itemNameRaw, hasThai } from './naming.js';

const txt = (v) => String(v ?? '').trim();
const norm = (v) => txt(v).toLowerCase().replace(/\s+/g, ' ');
const skuKey = (v) => txt(v).toUpperCase().replace(/[\s._-]/g, '');

export function commonPrefix(a, b) {
  const x = norm(a), y = norm(b);
  let i = 0;
  while (i < x.length && i < y.length && x[i] === y[i]) i++;
  return i;
}

// ชื่อที่ใช้เทียบรุ่น = ชื่ออังกฤษก่อน (กฎเดียวกับที่หน้าจอใช้ ดู naming.js)
//   ชื่อไทยใช้ไม่ได้ที่นี่: ทั้งรุ่นเขียนว่า "หมวกแก็ป" เหมือนกันหมด → ส่วนต่างเป็นศูนย์ จับรุ่นมั่ว
const label = (c) => itemNameRaw(c);

// ส่วนท้ายที่ต่างกัน — ใช้โชว์ให้คนตัดสินใจ ("ต่างกันที่: GREIGE → LIGHT GREEN")
//
// ⚠ บั๊กที่รีวิวจับได้ 26 ต.ค. 69 (อย่ากลับไปใช้ commonPrefix ตรงนี้):
//   ① commonPrefix นับตำแหน่งบนข้อความที่ยุบช่องว่างแล้ว แต่เดิมเอาไปตัดข้อความดิบ —
//      ชื่อจาก PDF มักมีช่องว่างซ้อน ("WINGFORT  OUTER") ตำแหน่งจึงเลื่อน โชว์ "EGREIGE → ELIGHT GREEN"
//      → ยุบช่องว่างของข้อความดิบก่อน แล้วเทียบ/ตัดบนข้อความชุดเดียวกัน
//   ② ตัดกลางคำ — GREIGE กับ GREEN ขึ้นต้น "GRE" เหมือนกัน เลยโชว์ "IGE → EN"
//      → ถอยไปต้นคำเสมอ ยกเว้นจุดตัดตรงรอยต่อคำพอดีทั้งสองฝั่ง
//   ทั้งสองข้อสำคัญเพราะแถวนี้คือสิ่งที่คนใช้ตัดสินว่า "ต่างกันแค่สีจริงไหม" ก่อนยอมให้ก๊อปวัสดุ/พิกัด
const squash = (v) => txt(v).replace(/\s+/g, ' ');
const atEdge = (s, i) => i >= s.length || s[i] === ' ';

export function diffTail(a, b) {
  const la = squash(label(a)), lb = squash(label(b));
  let i = 0;
  while (i < la.length && i < lb.length && la[i].toLowerCase() === lb[i].toLowerCase()) i++;
  if (!(atEdge(la, i) && atEdge(lb, i))) {
    while (i > 0 && la[i - 1] !== ' ') i--;
  }
  return { from: la.slice(i).trim() || '—', to: lb.slice(i).trim() || '—' };
}

function sameBrand(a, b) {
  return norm(a.brand) === norm(b.brand);
}

// จัดชั้นความมั่นใจ: 'sure' = ต่างกันแค่สี/ไซส์แน่ ๆ · 'maybe' = ใกล้เคียง ให้คนติ๊กเอง · null = ไม่เกี่ยว
export function siblingTier(me, other) {
  if (!other || other.id === me.id) return null;
  if (!sameBrand(me, other)) return null;

  const ka = skuKey(me.sku), kb = skuKey(other.sku);
  const la = label(me), lb = label(other);
  if (!la || !lb) return null;

  const nameShared = commonPrefix(la, lb);
  const nameRatio = nameShared / Math.min(norm(la).length, norm(lb).length);
  const skuShared = ka && kb ? commonPrefix(ka, kb) : 0;
  const skuTail = ka && kb ? Math.max(ka.length, kb.length) - skuShared : 99;

  // แน่ใจ: รหัสยาวเท่ากัน ต่างกันแค่ท้าย ≤3 ตัว และชื่อซ้ำกันเกิน 70%
  if (ka.length === kb.length && skuTail > 0 && skuTail <= 3 && nameShared >= 8 && nameRatio >= 0.7) return 'sure';

  // ใกล้เคียง: ชื่อซ้ำกันเกินครึ่ง และรหัสขึ้นต้นเหมือนกันพอสมควร
  if (nameShared >= 8 && nameRatio >= 0.5 && skuShared >= 6) return 'maybe';

  return null;
}

// me = ใบที่กรอกอยู่ · pool = ใบอื่นทั้งหมด → { sure, maybe } เรียงตามรหัส
export function siblingCandidates(me, pool, cap = 60) {
  const sure = [], maybe = [];
  for (const o of pool ?? []) {
    const tier = siblingTier(me, o);
    if (tier === 'sure') sure.push(o);
    else if (tier === 'maybe') maybe.push(o);
  }
  const bySku = (a, b) => txt(a.sku).localeCompare(txt(b.sku));
  return { sure: sure.sort(bySku).slice(0, cap), maybe: maybe.sort(bySku).slice(0, cap) };
}

// ── "แก้ใบนี้แล้วให้รุ่นเดียวกันเปลี่ยนตาม" (28 ต.ค. 69) ─────────────────────────
// user: "อัพเดทวัสดุ แหล่งผลิต หรือชื่อสินค้าแล้ว ยังเลือกให้สินค้าคล้าย ๆ กันอัพเดทตามได้ด้วย"
//   ที่มา: packing list Snow Peak บอกว่าหมวก/เสื้อผลิตจีน-เวียดนาม แต่ในระบบเป็น JP ทั้งรุ่น — แก้ทีละใบไม่ไหว
// ข้อห้าม ① ข้างบนยังอยู่ครบ (คนติ๊กเองทุกรายการ) · ข้อ ② ผ่อนเฉพาะ "ช่องที่คนเพิ่งแก้ในใบนี้":
//   · ใบที่ค่าเดิม = ค่าเดิมของใบนี้ (ก๊อปกันมา)         → เปลี่ยนตาม · ติ๊กไว้ให้ (ถ้าต่างกันแค่สี/ไซส์)
//   · ใบที่ช่องนั้นยังว่าง                                → เติมให้ · ติ๊กไว้ให้
//   · ใบที่ค่าเดิม "ไม่ตรง" กับค่าเดิมของใบนี้              → โชว์ว่าจะทับอะไร แต่ **ไม่ติ๊กให้** ต้องติ๊กเอง
//   · ช่องที่ไม่ได้แก้ในรอบนี้                              → เติมเฉพาะช่องว่างเหมือนเดิม ไม่ทับ
//   · ลบค่าทิ้ง (แก้เป็นว่าง)                               → ไม่ส่งต่อ (การลบไม่ใช่ข้อมูลใหม่)

const NAME_KEYS = new Set(['name_en', 'name_th']);

// ช่องที่เปลี่ยนตามได้ = ชื่อ + ทุกช่องที่เติมให้ได้
export const FOLLOWABLE = [
  ['name_en', 'ชื่ออังกฤษ'],
  ['name_th', 'ชื่อไทย'],
  ...FILLABLE,
];

// วัสดุเก็บเป็น "ผ้าฝ้าย, ผ้าโพลีเอสเตอร์" — ลำดับไม่มีความหมาย เทียบเป็นชุดคำ
const matSet = (v) => txt(v).split(',').map(s => norm(s)).filter(Boolean).sort().join('|');
// ชื่อเทียบแบบตรงตัวพิมพ์ — แก้ตัวพิมพ์เล็ก/ใหญ่ของชื่อ (RAIN HAT → Rain Hat) ก็นับว่าแก้ ช่องอื่นไม่สนตัวพิมพ์
const keyOf = (k, v) => k === 'material' ? matSet(v)
  : k === 'origin_country' ? txt(v).toUpperCase()
  : NAME_KEYS.has(k) ? squash(v) : norm(v);
export const sameValue = (k, a, b) => keyOf(k, a) === keyOf(k, b);
// ค่าที่เขียนจริง — ประเทศตัวใหญ่เสมอ (ช่องเลือกประเทศรู้จักเฉพาะตัวใหญ่ · คอลัมน์เป็น char(2))
const writeVal = (k, v) => k === 'origin_country' ? txt(v).toUpperCase() : txt(v);

// ── ชื่อ: เทียบเป็น "คำ" ตามตำแหน่ง ─────────────────────────────────────────────
// 🐛 รีวิว 28 ต.ค. 69 จับได้ว่าแบบเดิม (เทียบทีละตัวอักษร + หาส่วนเดิมที่ไหนก็ได้ในชื่อ) พัง 3 แบบ และติ๊กให้เองด้วย:
//   ① แทรกคำซ้ำ: แก้ใบที่ตกหล่น "Rain Hat GREIGE" → "Rain Hat 1 GREIGE" ใบที่มีอยู่แล้วกลายเป็น "Rain Hat 1 1 …"
//   ② ตัดกลางคำ: "Light Down" → "Light-Down" ได้ "Light- Down Jacket NAVY"
//   ③ แก้สี/ไซส์ของใบนี้เอง (BLACK → NAVY · M → L) ลามไปใบสีเดียวกันไซส์อื่น / ไซส์เดียวกันสีอื่น
// ⇒ เทียบทีละคำ · ส่วนเดิมต้องอยู่ "ตำแหน่งเดียวกัน" และคำข้างหน้าเหมือนกัน ·
//   ติ๊กให้ได้เฉพาะเมื่อคำที่แก้อยู่ใน "ชื่อรุ่น" (คำต้นชื่อที่ทั้งรุ่นใช้ร่วมกัน — modelWords คิดจากของรุ่นเดียวกันในแผง)
//   นอกนั้นโชว์เป็น 'check' (แถบส้ม ไม่ติ๊กให้) ให้คนดูเอง
const words = (v) => squash(v).split(' ').filter(Boolean);
const lc = (w) => String(w ?? '').toLowerCase();

// จำนวนคำต้นชื่อที่เหมือนกัน (ไม่สนตัวพิมพ์)
export function sharedWords(a, b) {
  const x = words(a), y = words(b);
  let i = 0;
  while (i < x.length && i < y.length && lc(x[i]) === lc(y[i])) i++;
  return i;
}

// ส่วนที่ถูกแก้ เป็นคำ — at = ตำแหน่งคำในชื่อเดิม · fromW/toW = คำเดิม/คำใหม่ · append = ต่อท้ายชื่อล้วน ๆ
//   "VACUME BEER TUMBLER 16OZ BLACK" → "THERMO TUMBLER 470 IN BLACK": at 0 · VACUME…16OZ → THERMO…IN
//   "Rain Hat BLACK" → "Rain Hat 1 BLACK": at 2 · [] → [1] (แทรก)
export function nameDelta(before, after) {
  const a = words(before), b = words(after);
  if (!a.length || !b.length) return null;
  let p = 0;
  while (p < a.length && p < b.length && a[p] === b[p]) p++;
  let s = 0;
  while (s < a.length - p && s < b.length - p && a[a.length - 1 - s] === b[b.length - 1 - s]) s++;
  const fromW = a.slice(p, a.length - s), toW = b.slice(p, b.length - s);
  if (!fromW.length && !toW.length) return null;
  return { at: p, fromW, toW, from: fromW.join(' '), to: toW.join(' '), append: !fromW.length && p === a.length };
}

// ชื่อของอีกใบหลังเปลี่ยนตาม → { to, kind: 'rename' | 'check' } หรือ null (ไม่แตะ)
//   opts.modelWords = จำนวนคำ "ชื่อรุ่น" ของรุ่นนี้ (คิดจากทุกแถวในแผง) · opts.tier = 'sure' | 'maybe' ของใบนั้น
// 🐛 รีวิวรอบสอง 28 ต.ค. 69 (14 ข้อจริง) — กฎที่ต้องคงไว้:
//   · คำที่ "เพิ่มเข้ามา" (มีในชื่อใหม่ ไม่มีในส่วนเดิม) ถ้าอีกใบมีอยู่แล้วที่ไหนก็ตาม → ไม่แตะ
//     (เดิมกันเฉพาะการแทรกล้วน — แก้ตัวพิมพ์+เติม "1" ในการบันทึกเดียวกันกลายเป็น "Rain Hat 1 1" แบบติ๊กให้)
//   · แทรกคำตรงรอยต่อชื่อรุ่นกับสี ("GREY" → "LIGHT GREY" รูปเดียวกับ "Rain Hat" → "Rain Hat 1") = check เสมอ
//   · ชื่อเหมือนกันทั้งชื่อก็ต้องผ่านกฎเดียวกัน (เดิมทางลัดนี้ข้ามกฎ ทำให้แก้ไซส์ลามไปไซส์อื่นที่ชื่อเดียวกัน)
export function nameFollow(before, after, target, { modelWords = Infinity, tier = 'sure' } = {}) {
  const a = words(before), t = words(target);
  const d = nameDelta(before, after);
  if (!d || !t.length) return null;
  if (squash(target) === squash(after)) return null;                 // เป็นชื่อใหม่อยู่แล้ว
  // "เพิ่มคำล้วน ๆ" รวมแบบที่คำเดิมยังอยู่ครบ ("Rain Hat" → "GORE-TEX Rain Hat 1") — เดิมนับเป็นการแทนที่
  //   แล้วหลุดกฎของการแทรก ทำให้แถวรุ่นใกล้เคียง "Rain Hat 2" ได้ "GORE-TEX Rain Hat 1 2" แบบติ๊กทั้งกลุ่มได้
  const toLc = d.toW.map(lc);
  const ins = !d.fromW.length || (d.toW.length > d.fromW.length && d.fromW.every(w => toLc.includes(lc(w))));
  const end = d.at + d.fromW.length;
  let out;
  if (squash(target) === squash(before)) {                           // ชื่อเหมือนกันทั้งชื่อ (ชื่อไทยกว้าง ๆ ทั้งรุ่น)
    out = squash(after);
  } else {
    if (d.append) return null;                                       // ต่อท้ายชื่อ = สี/ไซส์ของใบนี้เอง
    for (let i = 0; i < d.at; i++) if (lc(t[i]) !== lc(a[i])) return null;          // คำข้างหน้าต้องเหมือนกัน
    for (let i = 0; i < d.fromW.length; i++) if (lc(t[d.at + i]) !== lc(d.fromW[i])) return null;
    const fromSet = new Set(d.fromW.map(lc));
    const tSet = new Set(t.map(lc));
    if (d.toW.some(w => !fromSet.has(lc(w)) && tSet.has(lc(w)))) return null;     // มีคำที่จะเพิ่มอยู่แล้ว
    out = [...t.slice(0, d.at), ...d.toW, ...t.slice(end)].join(' ');
  }
  if (!out || out === squash(target)) return null;
  // ติ๊กทั้งกลุ่มได้: คำที่แก้อยู่ "ใน" ชื่อรุ่น (แทรก = ต้องอยู่ก่อนรอยต่อ ไม่ใช่ตรงรอยต่อ) ·
  //   ไม่ใช่การต่อท้าย · การแทรกเชื่อเฉพาะใบที่ต่างกันแค่สี/ไซส์ (รุ่นใกล้เคียงอาจเป็นรุ่นอื่น เช่น Rain Hat 2)
  const inModel = ins ? end < modelWords || (!d.fromW.length && d.at < modelWords) : end <= modelWords;
  const ok = !d.append && inModel && (!ins || tier === 'sure');
  return { to: out, kind: ok ? 'rename' : 'check' };
}

// ใช้ในเทสต์/ที่อื่นที่อยากได้แค่ชื่อผลลัพธ์
export const renameLike = (before, after, target, opts) => nameFollow(before, after, target, opts)?.to ?? null;

// ชื่อไทยที่ระบุสี/ไซส์ ("หมวกสีดำ" · "เสื้อ ไซส์ M") ใช้กับทั้งรุ่นไม่ได้ → ให้คนดูเอง
const VARIANT_TH = /สี\s*[ก-๛]|ไซ[สซ]์|ขนาด|เบอร์|\bsize\b|(^|\s)(XXS|XS|S|M|L|XL|XXL|XXXL|\d*XL)(\s|$)|\d+\s?(ซม|มม|cm|mm|ลิตร|ml|oz)/i;

// ช่องที่เพิ่งแก้ในใบนี้ (เทียบตอนเปิดกับหลังบันทึก) — ใบใหม่ไม่มี "ก่อนแก้" → ไม่มีอะไรส่งต่อ
export function changedFields(before, after) {
  if (!before?.id || !after) return [];
  const out = [];
  for (const [k, th] of FOLLOWABLE) {
    if (!txt(after[k])) continue;                       // แก้เป็นว่าง = ลบ → ไม่ส่งต่อ
    if (sameValue(k, before[k], after[k])) continue;
    const ch = { k, th, from: txt(before[k]), to: writeVal(k, after[k]) };
    if (k === 'name_en') {
      if (!ch.from) continue;                           // ชื่อเดิมว่าง → ไม่มีส่วนให้เทียบ
      ch.delta = nameDelta(ch.from, ch.to);
    }
    if (k === 'name_th') {
      // ชื่อไทยใหม่ต้องเป็นภาษาไทยจริงถึงจะส่งต่อ · โชว์ "เปลี่ยนเฉพาะส่วน" เฉพาะตอนแก้คำในชื่อไทยเดิม
      //   (แทนชื่ออังกฤษที่ค้างในช่องไทยด้วยชื่อไทย = เปลี่ยนทั้งช่อง ไม่ใช่แก้บางส่วน)
      if (!hasThai(ch.to)) continue;
      const d = hasThai(ch.from) ? nameDelta(ch.from, ch.to) : null;
      if (d && d.from !== words(ch.from).join(' ')) ch.delta = d;
    }
    out.push(ch);
  }
  return out;
}

// แผนของอีกใบ: จะเปลี่ยน/เติมอะไรบ้าง
//   me = ใบหลังบันทึก · changes = changedFields(...) · use = ช่องที่เปิดให้เปลี่ยนตาม (Set; null = ทุกช่องที่แก้)
//   opts = { model: { name_en, name_th } จำนวนคำชื่อรุ่น · tier: 'sure' | 'maybe' } (ดู nameFollow)
//   acts[].kind: 'follow' เปลี่ยนตาม (ค่าเดิมตรงกับใบนี้) · 'rename' ชื่อเปลี่ยนเฉพาะส่วนที่แก้ ·
//                'fill' เติมช่องว่าง · 'override' ทับค่าที่ไม่ตรงกับค่าเดิมของใบนี้ ·
//                'check' ชื่อที่อาจไม่ใช่ของรุ่นนี้ (แก้ถึงส่วนสี/ไซส์ · ชื่อไทยระบุสี) — สองแบบหลังไม่ติ๊กให้เด็ดขาด
//   skips = ชื่อที่แก้แต่ใบนี้เปลี่ยนตามไม่ได้ (ชื่อเดิมไม่ตรงรูปแบบ) — บอกคน ไม่ปล่อยให้ขึ้นว่า "ตรงแล้ว"
// holdMaterial = เหตุผล (ข้อความ) ที่ไม่ควรเดาวัสดุให้ใบนั้น · วัสดุที่เพิ่งแก้ = แถบส้ม ปิดเป็นช่องได้ ·
//   วัสดุที่ไม่ได้แก้รอบนี้ = ไม่เติมเลย (heldWhy) ไม่งั้นติ๊กแถวเพื่อเอาช่องอื่น วัสดุจะติดไปด้วยโดยแยกไม่ได้
export function planFor(me, target, changes = [], use = null, { model = {}, tier = 'sure', holdMaterial = null } = {}) {
  const patch = {};
  const acts = [];
  const skips = [];
  let heldWhy = null;
  const changed = new Map(changes.map(c => [c.k, c]));
  for (const [k, th] of FOLLOWABLE) {
    const cur = txt(target[k]);
    const ch = changed.get(k);
    if (ch) {
      if (use && !use.has(k)) continue;                 // คนปิดช่องนี้ไว้ → ไม่แตะเลย
      if (NAME_KEYS.has(k)) {
        if (sameValue(k, cur, ch.to)) continue;          // เป็นชื่อใหม่อยู่แล้ว
        const nf = cur ? nameFollow(ch.from, ch.to, cur, { modelWords: model[k] ?? Infinity, tier }) : null;
        if (nf) {
          // ชื่อไทยที่เพิ่งระบุสี/ไซส์ หรือแค่ต่อท้ายชื่อเดิม ("หมวก" → "หมวกดำ") = ของใบนี้เอง → ให้คนดู
          const thVariant = k === 'name_th' && ((VARIANT_TH.test(nf.to) && !VARIANT_TH.test(cur))
            || (hasThai(ch.from) && squash(ch.to).startsWith(squash(ch.from))));
          const kind = nf.kind === 'rename' && thVariant ? 'check' : nf.kind;
          patch[k] = nf.to; acts.push({ k, th, from: cur, to: nf.to, kind }); continue;
        }
        // ชื่อไทย = ชื่อสำแดงที่จงใจเขียนกว้าง ๆ ทั้งรุ่น ("หมวก" · "เสื้อยืด") → ส่งทั้งช่องได้
        //   ช่องว่าง / ยังเป็นชื่ออังกฤษค้าง (2,708 ใบ) = เติม · เป็นชื่อไทยอื่นอยู่แล้ว = ทับค่าที่ไม่ตรง (ไม่ติ๊กให้)
        //   ชื่อใหม่ระบุสี/ไซส์ ("หมวกสีดำ") หรือแค่ต่อท้ายชื่อเดิม = ให้คนดูเอง
        // ชื่ออังกฤษมีสี/ไซส์ของใครของมัน → ไม่เดาให้ (เปลี่ยนได้แค่แบบ nameFollow ข้างบน)
        if (k === 'name_th') {
          const appendOnly = hasThai(ch.from) && squash(ch.to).startsWith(squash(ch.from));
          let kind = !cur ? 'fill' : !hasThai(cur) ? 'follow' : sameValue(k, cur, ch.from) ? 'follow' : 'override';
          if (kind !== 'override' && (VARIANT_TH.test(ch.to) || appendOnly)) kind = 'check';
          patch[k] = ch.to;
          acts.push({ k, th, from: cur, to: ch.to, kind });
          continue;
        }
        if (cur) skips.push(th);
        continue;
      }
      if (sameValue(k, cur, ch.to)) continue;           // เป็นค่าใหม่อยู่แล้ว
      const kind = !cur ? 'fill' : sameValue(k, cur, ch.from) ? 'follow' : 'override';
      patch[k] = ch.to;
      acts.push({ k, th, from: cur, to: ch.to, kind });
      continue;
    }
    if (NAME_KEYS.has(k)) continue;                     // ชื่อที่ไม่ได้แก้ → ไม่แตะ
    if (!txt(me[k]) || cur) continue;                   // ช่องที่ไม่ได้แก้ → เติมเฉพาะช่องว่างเหมือนเดิม
    if (k === 'material' && holdMaterial) { heldWhy = holdMaterial; continue; }
    patch[k] = writeVal(k, me[k]);
    acts.push({ k, th, from: '', to: patch[k], kind: 'fill' });
  }
  if (holdMaterial) for (const a of acts) if (a.k === 'material') { a.kind = 'check'; a.why = holdMaterial; }
  // ⚠ พิกัดของอีกใบเปลี่ยน → "broker ยืนยันแล้ว" ของใบนั้นยืนยันพิกัดเดิม ไม่ใช่พิกัดใหม่ → ปลดออก
  //   (ไม่ก๊อป hs_confirmed ของใบนี้ไปเด็ดขาด — ข้อห้ามข้างบน)
  let unconfirm = false;
  if ('hs_code' in patch && target.hs_confirmed) { patch.hs_confirmed = false; unconfirm = true; }
  // ปลดคำยืนยัน broker ของใบนั้น = เรื่องที่ต้องดู → นับเป็นแถบส้ม ไม่ติ๊กให้ (รีวิวรอบสอง)
  const overrides = acts.filter(a => a.kind === 'override' || a.kind === 'check').length + (unconfirm ? 1 : 0);
  return { patch, acts, n: acts.length, overrides, unconfirm, skips, heldWhy };
}

